import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Google Business Profile
 */
export class GmbService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 11;
  }
  getTypeString(): string {
    return SiteTypeEnum.GoogleBusinessProfile;
  }
  getAllTasksTypes(): number[] {
    return [34];
  }
  getPublicTaskTypes(): number[] {
    // For favorites filtering
    return [34];
  }
  getTaskTypeString(taskType: number): string {
    const mapping = {
      34: 'gmb/msg',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      34: 'gmb-msg',
    };
    return mapping[taskType];
  }

  canHaveSurveys(): boolean {
    return false;
  }

  mustCheckIfMessageDeleted(): boolean {
    // All messages are public for GMB, so always check if message was deleted
    return true;
  }

  isQuickReplyEnable() {
    return 0;
  }
}
